import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axiosInstance';

// Check Login (shared if backend handles both user/admin)
export const checkLogin = createAsyncThunk(
    'auth/checkLogin',
    async (_, thunkAPI) => {
        try {
            const res = await axiosInstance.get('/auth/me');
            return res.data;
        } catch (err) {
            return thunkAPI.rejectWithValue(err.response?.data || 'Not authenticated');
        }
    }
);
// User Google Login
export const googleLogin = createAsyncThunk(
    'auth/googleLogin',
    async (token, thunkAPI) => {
        try {
            const res = await axiosInstance.post('/auth/google', { token });
            return res.data;
        } catch (err) {
            return thunkAPI.rejectWithValue(err.response?.data || 'Login failed');
        }
    }
);


// Admin Login
export const adminLogin = createAsyncThunk(
    'auth/adminLogin',
    async ({ email, password }, thunkAPI) => {
        try {
            const res = await axiosInstance.post('/auth/admin/login', { email, password });
            return res.data;
        } catch (err) {
            return thunkAPI.rejectWithValue(err.response?.data || 'Admin login failed');
        }
    }
);
// Logout
export const logoutUser = createAsyncThunk(
    'auth/logout',
    async (_, thunkAPI) => {
        try {
            const res = await axiosInstance.post('/auth/logout');
            return res.data;
        } catch (err) {
            return thunkAPI.rejectWithValue(err.response?.data || 'Logout failed');
        }
    }
);

const authSlice = createSlice({
    name: 'auth',
    initialState: {
        user: null,
        token: null,
        isLoggedIn: false,
        admin: null,
        adminToken: null,
        isAdminLoggedIn: false,
        loading: false,
        error: null,
    },
    reducers: {
        clearAuthState: (state) => {
            state.user = null;
            state.token = null;
            state.isLoggedIn = false;
            state.admin = null;
            state.adminToken = null;
            state.isAdminLoggedIn = false;

            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            // ========== ADMIN LOGIN ==========
            .addCase(adminLogin.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(adminLogin.fulfilled, (state, action) => {
                state.loading = false;
                state.admin = action.payload.user;
                console.log("aidm", state.admin)
                state.adminToken = action.payload.token;
                state.isAdminLoggedIn = true;
            })
            .addCase(adminLogin.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Admin login failed';
                state.isAdminLoggedIn = false;
            })

            // ========== USER LOGIN ==========
            .addCase(googleLogin.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(googleLogin.fulfilled, (state, action) => {
                state.loading = false;
                state.user = action.payload.user;
                state.token = action.payload.token;
                state.isLoggedIn = true;
            })
            .addCase(googleLogin.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'User login failed';
                state.isLoggedIn = false;
            })

            // ========== CHECK LOGIN ==========
            .addCase(checkLogin.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(checkLogin.fulfilled, (state, action) => {
                state.loading = false;

                if (action.payload.user?.role === 'admin') {
                    state.admin = action.payload.user;
                    state.isAdminLoggedIn = true;
                } else if (action.payload.user?.role === 'user') {
                    state.user = action.payload.user;
                    state.isLoggedIn = !!action.payload.user;
                }
            })
            .addCase(checkLogin.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Not authenticated';
                state.isLoggedIn = false;
                state.isAdminLoggedIn = false;
            })

            // ========== LOGOUT ==========
            .addCase(logoutUser.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(logoutUser.fulfilled, (state) => {
                state.loading = false;
                state.user = null;
                state.token = null;
                state.isLoggedIn = false;
                state.admin = null;
                state.adminToken = null;
                state.isAdminLoggedIn = false;
            })
            .addCase(logoutUser.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Logout failed';
                state.isLoggedIn = false;
            });
    },
});

export const { clearAuthState } = authSlice.actions;
export default authSlice.reducer;